/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useLayoutEffect, useState } from 'react';
import FJUtil from '../../../../util/FJUtil.js';
import FJRetry from '../../../../common/components/FJRetry/FJRetry';
import styles from './FJMediaImportFile.module.less';
import classNames from 'classnames';
import FJGradation from '../../../../common/components/FJGradation/FJGradation.tsx';
import FJMediaDuration from './FJMediaDuration.tsx';
import FJStringUtil from '@src/util/FJStringUtil';

interface MediaImportItem {
    id: string;
    name?: string;
    thumbnail?: string;
    [key: string]: any;
}

interface FJMediaImportFileProps {
    itemModel: MediaImportItem;
    onClick?: (id: string) => void;
    onDoubleClick?: (id: string) => void;
    className?: string;
    wrapperClassName?: string;
    selected?: boolean;
    supportSelect?: boolean;
    showDuration?: boolean;
    duration?: number;
}

const FJMediaImportFile: React.FC<FJMediaImportFileProps> = ({
    itemModel,
    onClick,
    onDoubleClick,
    className,
    wrapperClassName,
    selected,
    supportSelect,
    showDuration,
    duration,
}) => {
    const [fileName, setFileName] = useState<string | undefined>(itemModel.name);
    const [imageUrl, setImageUrl] = useState<string | undefined>(itemModel.thumbnail);
    const [imageStatus, setImageStatus] = useState<'initial' | 'loaded' | 'error'>('initial');

    useLayoutEffect(() => {
        const data: any = FJStringUtil.getEspText(itemModel.name, 12, 140 - 10);
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setFileName(data.fileText);
    }, [itemModel.name]);

    const onImageLoad = () => {
        setImageStatus('loaded');
    };

    const onImageError = () => {
        setImageStatus('error');
        setImageUrl('');
    };

    const refresh = useCallback(() => {
        setImageStatus('initial');
        setImageUrl(itemModel.thumbnail);
    }, [itemModel.thumbnail]);

    const Wrapper = supportSelect ? FJGradation : React.Fragment;

    const handleClick = () => {
        if (supportSelect) {
            onClick?.(itemModel.id);
        }
    };

    const handleDoubleClick = () => {
        onDoubleClick?.(itemModel.id);
    };

    return (
        <div
            className={classNames(styles.container, className)}
            onClick={handleClick}
            onDoubleClick={handleDoubleClick}
        >
            <Wrapper {...(supportSelect ? { active: selected, className: wrapperClassName, borderRadius: 6 } : {})}>
                <div className={styles.thumbnail}>
                    {imageUrl ? (
                        <img
                            src={imageUrl}
                            alt={fileName}
                            draggable={false}
                            onLoad={onImageLoad}
                            onError={onImageError}
                        />
                    ) : null}

                    <FJRetry refreshCallback={refresh} isShow={imageStatus === 'error'} />

                    {showDuration && duration && !selected ? (
                        <FJMediaDuration duration={FJUtil.secondToInstant(duration, duration > 3600) as string} />
                    ) : null}
                </div>
            </Wrapper>

            <div className={styles.name} title={itemModel.name}>
                {fileName}
            </div>
        </div>
    );
};

export default FJMediaImportFile;
